import { useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { useSelector } from "react-redux";
import { BookOpen, Users, ChevronRight, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { stripePromise } from "../../constants/constants";
import VirtualCourses from "../virtualCourses/VirtualCourses";
import FilterSidebar from "./FilterSidebar";
import Tabs from "../tabs/Tabs";
import { COLORS } from "../../constants/colors";

const CourseTabContent = ({ icon: Icon, title, description, courseType, filters }) => (
  <div className="bg-white border-2 border-gray-300 rounded-lg shadow-lg p-3">
    <div className="mb-8">
      <div className="flex items-start gap-3 mb-2">
        <div className="mt-2 w-10 h-10 rounded-lg flex items-center justify-center shadow-sm" style={{ backgroundColor: COLORS.purple }}>
          <Icon className="w-5 h-5 text-white" />
        </div>
        <div>
          <h1 className="text-xl font-bold text-gray-900">{title}</h1>
          <p className="text-gray-500 text-sm">{description}</p>
        </div>
      </div>
    </div>
    <Elements stripe={stripePromise}>
      <VirtualCourses type={courseType} filters={filters} />
    </Elements>
  </div>
);

const OnTrackCoursesPage = () => {
  const { currentJob, targetJob } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const [filters, setFilters] = useState({});

  const handleBack = () => {
    navigate("/dashboard/career-discovery/career-recommendations");
  };

  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
  };

      const tabs = [
      {
        key: "ontrack-courses",
        label: "Ontrack Career Courses",
        icon: BookOpen,
        content: (
          <CourseTabContent
            icon={BookOpen}
            title="Ontrack Career Courses"
            description="Curated courses designed specifically for career transformation"
            courseType="ontrack"
            filters={filters}
          />
        ),
      },
      {
        key: "partner-courses",
        label: "Partner Institution Courses",
        icon: Users,
        content: (
          <CourseTabContent
            icon={Users}
            title="Partner Institution Courses"
            description="Premium courses from leading educational institutions and industry partners"
            courseType="partnerinstitution"
            filters={filters}
          />
        ),
      },
    ];

  return (
    <div className="min-h-screen">
      <div className="max-w-7xl mx-auto px-3">
        <div className="flex flex-col lg:flex-row gap-8">
          <div className="flex-1 ">
            <Tabs tabs={tabs} paramKey="courseTab" />
          </div>
          <div className="w-full mt-1 lg:w-64 flex-shrink-0">
            <FilterSidebar onFiltersChange={handleFiltersChange} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnTrackCoursesPage;
